import { Stack, styled } from '@mui/material';

export const GroupCardWrapper = styled(Stack)<{ active?: boolean }>`
  height: 100%;
  background-color: ${({ active, theme }) =>
    active ? theme.palette.primary[50] : theme.palette.grey[100]};
  padding: ${({ theme }) => theme.spacing(6, 5.5, 5, 4)};
  border-radius: ${({ theme }) => theme.spacing(4)};
  cursor: pointer;
`;
export const ImageContainer = styled('div')`
  min-width: ${({ theme }) => theme.spacing(24)};
  width: ${({ theme }) => theme.spacing(24)};
  height: ${({ theme }) => theme.spacing(24)};
  border-radius: ${({ theme }) => theme.spacing(12)};
  overflow: hidden;
  background: #fff;
  position: relative;
`;
